<script>
    // get user info such as full name, education status; if their highest degree is Mittelschulabschluss, offer to only show questions related to ausbildungen
    import ContentBox from "../layouts/ContentBox.svelte";
    import PageBox from "../layouts/PageBox.svelte";
    import InputField from "../ui_elements/InputField.svelte";
    import SelectField from "../ui_elements/SelectField.svelte";
    import Button from "../ui_elements/Button.svelte";
    import { push } from "svelte-spa-router";
    import { onMount } from "svelte";
    import { post, getData } from "../utility.js";

    let firstName;
    let lastName;
    let educationBackground = '';
    let ausbildungenOnly = false;
    let information = '';
    let redirectTo = '';

    const educationBackgrounds = ["Mittelschulabschluss", "Realschulabschluss", "Abitur", "Universitätsabschluss (Bachelor/Master)"]

    onMount(async () => {
        // save redirect to protected page user originally wanted to access
        const hash = window.location.hash;
        if (hash.indexOf('?') !== -1){ 
            const urlParams = new URLSearchParams(hash.split('?')[1]);
            redirectTo = urlParams.get('redirectTo');
        }

        const data = await getData('get-user-info/');
        firstName = data.firstName;
        lastName = data.lastName;
        educationBackground = data.educationBackground;
        ausbildungenOnly = data.ausbildungenOnly;

    });

    async function submitInformation() {
        try {
            const response = post('submit-user-info/', { 
                firstName: firstName, 
                lastName: lastName,
                educationBackground: educationBackground,
                ausbildungenOnly: ausbildungenOnly,
            });         
            information = "Deine Angaben wurden gespeichert";               
        } catch (err) {
            information = err.message;
        }
        if (redirectTo) {
            push('/questionnaire');
        }
    }
</script>

<PageBox pageTitle="Informationen über dich">
    <ContentBox>
        <div class="text-secondary-text font-bold">Informationen über dich</div>
        <p>Bevor du mit dem Fragebogen anfängst, brauchen wir noch ein paar kurze Informationen von dir:</p>
        
        <p>Dein Vor- und Nachname werden am Ende für das Erstellen des Gutachtens mit den Ergebnissen verwendet.</p>
        <div class="w-full flex -mx-3 mb-6">
            <InputField bind:value={firstName} id="vorname" autocomplete="given-name" label="Vorname" placeholder="Dein Vorname" />         
            <InputField bind:value={lastName} id="nachname" autocomplete="family-name" label="Nachname" placeholder="Dein Nachname" />         
        </div>

        <p>Dein Bildungsabschluss kann über die Fragen und Ergebnisse entscheiden, die dir angezeigt werden.</p>
        <div class="flex items-start mb-4">      
            <SelectField bind:value={educationBackground} width="" id="educationBackground" label="Höchster (aktuell angestrebter) Bildungsabschluss">
                {#each educationBackgrounds as type}
                    <option value={type}>{type}</option>
                {/each}
            </SelectField>
        </div>

        {#if educationBackground=="Mittelschulabschluss"}
            <p>Möchtest du nur Ausbildungen als Berufsempfehlungen bekommen?</p>
            <p>Falls du auch Studiengangsempfehlungen erhalten willst, gibt es einige zusätzliche Fragen im Fragebogen.</p>
            
            <input type="checkbox" bind:checked={ausbildungenOnly} id="ausbildungenOnly" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
            <label for="ausbildungenOnly" class="py-1 ms-2">Ich möchte nur Ausbildungen empfohlen bekommen.</label>
        {/if}

        {#if redirectTo == "questionnaire"}
            <Button on:click={submitInformation} variant="submit">Speichern und Fragebogen starten</Button>
        {:else}
            <Button on:click={submitInformation} variant="submit">Informationen speichern</Button>
        {/if}

        <p>{information}</p>
    </ContentBox>
</PageBox>
